import React, { useCallback, useContext, useEffect, useRef, useState, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReportName } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import "../../../../stylesheets/components/Reports/HoldingReports/StockDetails.scss";
import "react-sliding-pane/dist/react-sliding-pane.css";
import * as URLConfig from "@frameworks/web/config/domain";
import { EMTReportCallBack, ThirdPartyCallBack, LoginSource, } from "@domains/utils/emtReportCallback";
import ReportValue from "../../../generic/commonTableVal";
import { accountDetails } from "@di";
import holdingDi from "../di/servicelocator";
import { retrieveExtPlatAccDataThunks } from "@frameworks/web/redux/reducers/RetrieveExtPlatAccData";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import { OverviewTable } from "@frameworks/web/components/Reports/overview";
import { TransactionTable } from "@frameworks/web/components/Reports/TransactionTable";
import TxnDetail from "@frameworks/web/components/Reports/PNLReports/PnlStockDetails/TxnDetail";
import { TransactionType } from "@domains/aggregates/interfaces/Reports/iPNLTransactionReport";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { createSearchParams, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { getDay } from "@domains/utils/reportDates";
import SmcasePopupFail from "../SMCaseLoadPopup/SmcasePopupFail";
import SmcasePopupSuccess from "../SMCaseLoadPopup/SmcasePopupSuccess";
import PopupLoader from "../SMCaseLoadPopup/SmcasePopupLoader";
import HoldingOverView from "./HoldingOverView";
import _ from "underscore";
import useOutSideClick from "@frameworks/web/components/generic/customHooks/useOutSideClick";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import { AssetType } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import InsuranceDetails from "./InsuranceDetails";
const StockDetails = ({ openDrawer, setOpenDrawer, selectedRowIndex, disableOutScroll, loader, setLoader, defaultSideBarTab, setDefaultSideBarTab, fromDate, endDate, assetType, editTransaction, isMyaccount, accCode, setDownloadAif, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const ref = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const holdingsDetails = useSelector((state) => { var _a, _b; return (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.HoldingDetails; });
    const activeHoldingTabName = useSelector((state) => { var _a; return (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.activeAssetTab; });
    const AccountDetails = useSelector((state) => state.accountDetailsReducer);
    useOutSideClick(ref, () => setOpenDrawer(false));
    const { txnStatus: txnStatusError } = useSelector((state) => state.pnltranasactionReport);
    const [editPNLTransactionAPICall, seteditPNLTransactionAPICall] = React.useState(false);
    const [editPNLTransactionFail, setEditPNLTransactionFail] = useState(false);
    const [editPNLTransactionSuccess, setEditPNLTransactionSuccess] = useState(false);
    const [isDirectMf, setIsDirectMf] = useState(false);
    const [isMfInf, setIsMfInf] = useState(false);
    const editTXNShimmer = useSelector((state) => state.pnltranasactionReport.editTXNShimmer);
    const webConfig = useContext(WebConfigContext);
    const { loginOrigin } = useParams();
    const item = holdingsDetails[selectedRowIndex];
    const StockHandler = useCallback((item, action) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        localStorage.setItem("description", "" + ((_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.description));
        localStorage.setItem("prefered_site", "old");
        if (((_b = item === null || item === void 0 ? void 0 : item.quote) === null || _b === void 0 ? void 0 : _b.edelweissProductCode) == "MF") {
            localStorage.setItem("isin", "" + ((_c = item === null || item === void 0 ? void 0 : item.quote) === null || _c === void 0 ? void 0 : _c.isin));
            localStorage.setItem("assetType", "" + "Mutual Fund");
        }
        else {
            localStorage.setItem("displayName", "" + ((_d = item === null || item === void 0 ? void 0 : item.quote) === null || _d === void 0 ? void 0 : _d.displayName));
            localStorage.setItem("tradingSymbol", "" + ((_e = item === null || item === void 0 ? void 0 : item.quote) === null || _e === void 0 ? void 0 : _e.tradingSymbol));
            localStorage.setItem("action", action);
        }
        const data = {
            sym: (_f = item === null || item === void 0 ? void 0 : item.quote) === null || _f === void 0 ? void 0 : _f.symbol,
            aTyp: (_g = item === null || item === void 0 ? void 0 : item.quote) === null || _g === void 0 ? void 0 : _g.edelweissProductCode,
            dpName: (_h = item === null || item === void 0 ? void 0 : item.quote) === null || _h === void 0 ? void 0 : _h.displayName,
            tSym: (_j = item === null || item === void 0 ? void 0 : item.quote) === null || _j === void 0 ? void 0 : _j.tradingSymbol,
            isin: (_k = item === null || item === void 0 ? void 0 : item.quote) === null || _k === void 0 ? void 0 : _k.isin,
            action,
        };
        EMTReportCallBack(AccountDetails.lgnSrc, ThirdPartyCallBack.BuySell, data);
        getAccountDataFromExPlat();
    }, [item, AccountDetails]);
    const redirectBuyOrSellLink = useCallback((loader) => {
        if (loader !== undefined && loader)
            return "";
        else {
            setLoader(loader);
            if (AccountDetails.lgnSrc != LoginSource.IPHONE &&
                AccountDetails.lgnSrc != LoginSource.ANDROID) {
                window.open(URLConfig.config.oldWebUrl, "_blank");
            }
        }
    }, []);
    const getAccountDataFromExPlat = useCallback(async () => {
        const loginSource = await accountDetails.getLoginSrc();
        if (loginSource && loginSource === LoginSource.TX3) {
            setLoader(true);
            dispatch(retrieveExtPlatAccDataThunks(redirectBuyOrSellLink));
        }
        else {
            redirectBuyOrSellLink(false);
        }
    }, []);
    const handleClassesToOpenCloseSideabar = useCallback(() => {
        if (ref.current) {
            if (openDrawer) {
                ref.current.classList.add("open");
                ref.current.classList.remove("close");
            }
            else {
                ref.current.classList.add("close");
                ref.current.classList.remove("open");
            }
        }
    }, [openDrawer, ref]);
    const checkDirectMf = async (item) => {
        var _a;
        if (((_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.description.toLowerCase().indexOf("direct")) > -1) {
            setIsDirectMf(true);
            setIsMfInf(await accountDetails.getmfInf());
        }
        else
            setIsDirectMf(false);
    };
    const viewCta = (type, item) => {
        var _a;
        const qureyParmaObj = {
            isin: (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.isin,
            scripName: item.scripName,
            companyName: item.quote.description,
            qty: String(item.quantity),
            ltp: String(item.quote.lastTradedPrice),
            scripIdentifier: item.scripIdentifier,
            fromDate: fromDate.toString(),
            toDate: endDate.toString(),
            transactionType: type,
            assetType: assetType,
            change: String(item.quote.change),
            changePercentage: String(item.quote.changePercentage),
            accCode: window.btoa(accCode).toString(),
            edelweissProductCode: item.quote.edelweissProductCode,
        };
        holdingDi.holdingReport.LThreeWindowbackClick = true;
        navigate({
            pathname: "/view-pnl-transaction-report",
            search: `?${createSearchParams(qureyParmaObj)}`,
        }, {
            state: {
                reportType: ReportName.HOLDINGS,
                activeHoldingTabName: activeHoldingTabName,
            },
        });
    };
    useEffect(() => {
        if (editPNLTransactionAPICall &&
            txnStatusError &&
            txnStatusError.isOpen !== null &&
            DeviceContext().isDesktop) {
            if (txnStatusError.isOpen)
                setEditPNLTransactionSuccess(true);
            else
                setEditPNLTransactionFail(true);
        }
    }, [txnStatusError, editPNLTransactionAPICall]);
    useEffect(() => {
        checkDirectMf(item);
    }, [item]);
    React.useLayoutEffect(() => {
        handleClassesToOpenCloseSideabar();
    }, [openDrawer, ref]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `stock-details `, ref: ref }, (item === null || item === void 0 ? void 0 : item.quote.assetCode) == AssetType.LIFE_INSURANCE ? (React.createElement(InsuranceDetails, { setOpenDrawer: setOpenDrawer, item: item })) : (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("div", { className: "stock-details-head" },
                    React.createElement("div", { className: "stock-details-switch-key", onClick: (e) => {
                            setOpenDrawer(false);
                        } },
                        React.createElement("i", { className: "edel-icon-arrow-right1" })),
                    React.createElement("div", { className: "stock-details-head-upper" },
                        React.createElement("span", null, (_a = item === null || item === void 0 ? void 0 : item.quote) === null || _a === void 0 ? void 0 : _a.isin),
                        React.createElement("span", null, (_b = item === null || item === void 0 ? void 0 : item.quote) === null || _b === void 0 ? void 0 : _b.exchange)),
                    React.createElement("div", { className: "stock-details-head-mid" },
                        React.createElement("span", { className: "scrips-stocks" },
                            (item === null || item === void 0 ? void 0 : item.scripName)
                                ? item === null || item === void 0 ? void 0 : item.scripName
                                : item === null || item === void 0 ? void 0 : item.quote.displayName,
                            React.createElement("i", { className: "edel-icon-stock-briefcase" }),
                            React.createElement("span", { className: "holdings-count" }, item === null || item === void 0 ? void 0 : item.quantity)),
                        React.createElement(ReportValue, { val: (_c = item === null || item === void 0 ? void 0 : item.quote) === null || _c === void 0 ? void 0 : _c.lastTradedPrice, stream: false, onlyval: false })),
                    React.createElement("div", { className: "stock-details-head-bottom justify-content-end" },
                        React.createElement("span", null,
                            React.createElement(ReportValue, { val: (_d = item === null || item === void 0 ? void 0 : item.quote) === null || _d === void 0 ? void 0 : _d.change, stream: false, onlyval: false }),
                            "\u00A0",
                            React.createElement(ReportValue, { val: (_e = item === null || item === void 0 ? void 0 : item.quote) === null || _e === void 0 ? void 0 : _e.changePercentage, stream: true, onlyval: false, percentage: true })))),
                React.createElement("div", { className: "stock-details-body" },
                    React.createElement("div", { className: "transaction-table-block" },
                        React.createElement(GenericTabs, { defaultActiveKey: defaultSideBarTab, callBackFunction: (key) => setDefaultSideBarTab(key), TabsClassName: "nav-fill", tabsArray: [
                                {
                                    eventKey: "overview",
                                    tabContent: defaultSideBarTab === "overview" && (React.createElement(OverviewTable, { children: React.createElement(HoldingOverView, { key: "overview", item: item, setDownloadAif: setDownloadAif, setOpenDrawer: setOpenDrawer }) })),
                                    title: "Overview",
                                },
                                {
                                    eventKey: "transaction",
                                    tabContent: defaultSideBarTab === "transaction" && (React.createElement(React.Fragment, null,
                                        React.createElement(TransactionTable, { key: "transaction", item: item, fromDate: fromDate, endDate: endDate, transactionType: TransactionType.UNREALISED, assetType: assetType, editTransaction: editTransaction, ReportName: ReportName.HOLDINGS, isMyaccount: isMyaccount, accCode: accCode }),
                                        React.createElement(TxnDetail, { className: "d-flex justify-content-end", viewText: "View all transaction with details", viewCta: () => viewCta(TransactionType.UNREALISED, item), stockName: item === null || item === void 0 ? void 0 : item.displayName }))),
                                    title: "Transaction Details",
                                },
                            ] }))),
                webConfig.allowTrading && loginOrigin !== LoginSource.SALES && (React.createElement(React.Fragment, null, ((_f = item === null || item === void 0 ? void 0 : item.quote) === null || _f === void 0 ? void 0 : _f.tradingSymbol) ||
                    (((_g = item === null || item === void 0 ? void 0 : item.quote) === null || _g === void 0 ? void 0 : _g.edelweissProductCode) == "MF" &&
                        ((_h = item === null || item === void 0 ? void 0 : item.quote) === null || _h === void 0 ? void 0 : _h.isin) &&
                        !item.physical) ? (React.createElement("div", { className: "stock-details-footer" },
                    (!isDirectMf || (isDirectMf && isMfInf)) && (React.createElement("div", { className: "action" },
                        React.createElement("button", { id: "buy", disabled: !isMyaccount, onClick: () => StockHandler(item, "BUY") }, "Buy"))),
                    React.createElement("div", { className: "action" },
                        React.createElement("button", { id: "sell", disabled: !isMyaccount, onClick: () => StockHandler(item, "SELL") }, "Sell")))) : (React.createElement(React.Fragment, null)))))))),
        React.createElement(React.Fragment, null,
            editTXNShimmer && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupLoader, { Title: "Transaction", message: `` })))),
            editPNLTransactionSuccess && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(SmcasePopupSuccess, { setDownloadSuccess: setEditPNLTransactionSuccess, isDownload: false, Title: "Edit PNL Transaction", operation: null, pageName: "to Holdings", tabName: "", message: "Your request was successfully processed.<br/>" +
                            "Updated price will reflect in the P&L on " +
                            moment(getDay(1)).format("DD-MM-yyyy") +
                            ".", sendBack: true, goBack: () => setEditPNLTransactionSuccess(false) })))),
            editPNLTransactionFail && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(SmcasePopupFail, { isDownload: false, setDownloadFail: setEditPNLTransactionFail, Title: "Edit PNL Transaction ", operation: null, pageName: "to Holdings", message: React.createElement("span", { className: "update-message" },
                            txnStatusError.error.getErrorMessege(),
                            " "), sendBack: true, goBack: () => setEditPNLTransactionFail(false) })))))));
};
export default React.memo(StockDetails, (prev, next) => _.isEqual(prev, next));
